module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step3-f672343bb48b631ed4dacb88071d463f.jpg";